import { axiosClient } from "../api/config";
import useAuth from "./useAuth";

const useRefreshToken = () => {
  const { setAuth } = useAuth();

  const refresh = async () => {
    const response = await axiosClient.post("/users/refresh", {
      withCredentials: true,
    });

    setAuth((prev) => {
      return {
        ...prev,
        role: response.data.data.user_type,
        token: response.data.data.token,
      };
    });
    return response.data.data.token;
  };
  return refresh;
};

export default useRefreshToken;
